import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';
import { drawAciGlyph } from './aciLeaf';

const ICON_SIZE = 40;

const APIC_TEXT_PATH =
  'M.2393 10.0586L3.0078 2.876L4.3945 2.876L7.1582 10.0586L5.7373 10.0586L5.1758 8.5791L2.2461 8.5791L1.6602 10.0586L.2393 10.0586ZM4.6631 7.2461L3.7109 4.7803L2.7539 7.2461L4.6631 7.2461ZM8.2129 10.0586L8.2129 2.876L9.6631 2.876Q10.8398 2.876 11.3599 3.0933Q11.8799 3.3105 12.1802 3.7964Q12.4805 4.2822 12.4805 4.9609L12.4805 4.9609Q12.4805 5.7129 12.0874 6.2109Q11.6943 6.709 11.0205 6.9043L11.0205 6.9043Q10.625 7.0166 9.5801 7.0166L9.5801 7.0166L9.5801 10.0586L8.2129 10.0586ZM9.5801 4.2139L9.5801 5.6836L10.0146 5.6836Q10.5273 5.6836 10.7275 5.6104Q10.9277 5.5371 11.0425 5.3687Q11.1572 5.2002 11.1572 4.9609L11.1572 4.9609Q11.1572 4.5459 10.835 4.3555L10.835 4.3555Q10.6006 4.2139 9.9658 4.2139L9.9658 4.2139L9.5801 4.2139ZM13.7207 10.0586L13.7207 2.876L15.0781 2.876L15.0781 10.0586L13.7207 10.0586ZM23.2178 4.1406L23.2178 4.1406L22.2607 5.0537Q21.2842 4.0234 20.0635 4.0234L20.0635 4.0234Q19.0332 4.0234 18.3276 4.7266Q17.6221 5.4297 17.6221 6.46L17.6221 6.46Q17.6221 7.1777 17.9346 7.7344Q18.2471 8.291 18.8184 8.6084Q19.3896 8.9258 20.0879 8.9258L20.0879 8.9258Q20.6836 8.9258 21.1768 8.7036Q21.6699 8.4814 22.2607 7.8955L22.2607 7.8955L23.1885 8.8623Q22.3926 9.6387 21.6846 9.939Q20.9766 10.2393 20.0684 10.2393L20.0684 10.2393Q18.3936 10.2393 17.3267 9.1772Q16.2598 8.1152 16.2598 6.4551L16.2598 6.4551Q16.2598 5.3809 16.7456 4.5459Q17.2314 3.7109 18.1372 3.2031Q19.043 2.6953 20.0879 2.6953L20.0879 2.6953Q20.9766 2.6953 21.7993 3.0713Q22.6221 3.4473 23.2178 4.1406Z';

function createApicIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${makeTag('path', {
      d: APIC_TEXT_PATH,
      transform: 'translate(8, 0.5)',
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    })}
    ${drawAciGlyph(14)}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const apicIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createApicIcon,
);
